import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from "rxjs";

@Injectable()
export class CustomSectionService {
  private readonly _loadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public readonly loading$: Observable<boolean> = this._loadingSubject.asObservable();

  public setLoading(value: boolean): void {
    this._loadingSubject.next(value);
  }
}
